import { useId } from 'react';
import { createEvent } from '../utilities/createEvent';

export const useModal = (props) => {
  const { isDanger, onClose } = props;

  const id = useId();

  const modalId = 'modal' + id;
  const nameId = 'modal-name' + id;

  const closeModal = () => createEvent(onClose);

  const modalProps = (ref, props) => {
    const kbd = {
      onMouseDown: (e) => e.stopPropagation(), // prevent close on mouse down
    };

    const rps = {
      id: modalId,
      role: isDanger ? 'alertdialog' : 'dialog',
      tabIndex: -1,
      'aria-labelledby': nameId,
    };

    const rct = {
      ref,
    };

    return {
      ...kbd,
      ...rps,
      ...rct,
      ...props,
    };
  };

  const exitProps = (ref, props) => {
    const { dontCloseOnClick, onClick, ...rest } = props;

    const onClickHandler = () => {
      createEvent(onClick);
      !dontCloseOnClick && closeModal();
    };

    const kbd = {
      onClick: onClickHandler,
    };

    const rps = {
      'aria-label': 'Close modal',
    };

    const rct = {
      ref,
    };

    return {
      ...kbd,
      ...rps,
      ...rct,
      ...rest,
    };
  };

  const nameProps = (ref, props) => {
    const rps = {
      id: nameId,
    };

    const rct = {
      ref,
    };

    return {
      ...rps,
      ...rct,
      ...props,
    };
  };

  return {
    closeModal, // used by Layer component
    modalProps,
    exitProps,
    nameProps,
  };
};
